<template>
    <div :style="{ height: height, width: width }">
        <l-map :zoom="zoom" :center="center" class="map-container" :options="{'zoomControl': showZoom, preferCanvas: true }">

            <l-tile-layer :url="url" :attribution="attribution" />
            <v-marker-cluster :options="clusterOptions">
                <l-marker
                  v-for="marker in markers"
                  :key="marker.id"
                  :visible="marker.visible"
                  :draggable="false"
                  :lat-lng.sync="marker.position"
                  :icon="marker.icon"
                  @click="filterByLocation(marker.properties.display_name)">
                  <l-tooltip :content="marker.tooltip" />
                </l-marker>
            </v-marker-cluster>
        </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

L.DomUtil.TRANSITION = false;

export default {
    props: {
        records: { type: Array, required: true },
        height: { type: String, required: false, default: '100vh'} ,
        width: { type: String, required: false, default: '100vw'},
        zoom: { type: Number, required: false, default: 10 },
        center: { type: Array, required: false, default: function () { return [47.5183, 8.9773] } },
        showZoom: { type: Boolean, required: false, default: true },
        tileUrl: { type: String, required: false, default: "http://{s}.tile.osm.org/{z}/{x}/{y}.png" },
        tileAttribution: { type: String, required: false, default: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' },
        clusterOptions: { type: Object, required: false, default: function () { 
            return { polygonOptions: {  fillColor: '#97ABAE',
                                        color: '#97ABAE',
                                        weight: .5,
                                        opacity: 0.7,
                                        fillOpacity: 0.4
                                     }
                    } 
            } 
        },
    },

    components: {
        LMap,
        LTileLayer,
        LMarker,
        LTooltip,
        'v-marker-cluster': Vue2LeafletMarkerCluster
    },

    data () {
        return {
            loading: false,
            show: true,
            enableTooltip: true,
            markers: [],
            fillColor: '#e4ce7f',
            zoomPosition: 'topright',
            url: this.tileUrl,
            attribution: this.tileAttribution
        }
    },

    watch: {
        records: function (newRecords) {
            this.updateMarkers();
        }
    },

    created () {
        this.loading = true;
        this.updateMarkers();
    },

    methods: {
        filterByLocation(locationName) {
            EventDispatcher.fire('locationFilterApplied', locationName);
            EventDispatcher.fire('openSidebar');
        },
        updateMarkers() {
            var markers = [];
            this.records.forEach(record => {
                var marker = {
                    properties: {
                        id: record.id,
                        display_name: record.display_name,
                    },
                    position: {
                        lat: record.coordinates.coordinates[1],
                        lng: record.coordinates.coordinates[0]
                    },
                    icon:  L.icon({
                        iconUrl: record.markerUrl,
                        iconRetinaUrl: record.markerUrl,
                        iconAnchor: [14, 40],
                        tooltipAnchor: [-6, 16]
                    }),
                    draggable: false,
                    visible: true,
                    tooltip: '<div>' + record.display_name + '</div>'
                };
                markers.push(marker);
                this.loading = false;
            });
            this.markers = markers;
        }
    }
}
</script>

<style lang="scss" scoped>
    .map-container {
        z-index: 0;
    }
</style>